import type {
  ParsedJsonUpload,
  PipelineStepId,
  PipelineStepState,
} from '../types';
import { PIPELINE_STEP_IDS } from '../types';
import { buildStepInput } from '../utils';

export function createInitialStepState(): PipelineStepState {
  return {
    status: 'idle',
    input: null,
    output: null,
    error: null,
    streamTotal: 0,
    streamProgress: null,
    streamItems: [],
    streamMode: 'live',
  };
}

export function createInitialSteps(): Record<
  PipelineStepId,
  PipelineStepState
> {
  return {
    lin: createInitialStepState(),
    adie: createInitialStepState(),
    ics: createInitialStepState(),
    de: createInitialStepState(),
  };
}

export function resolvePipelineStepInput(
  current: Record<PipelineStepId, PipelineStepState>,
  stepId: PipelineStepId,
  uploads: ParsedJsonUpload[],
): unknown {
  const stepIndex = PIPELINE_STEP_IDS.indexOf(stepId);
  const previousStepId =
    stepIndex > 0 ? PIPELINE_STEP_IDS[stepIndex - 1] : undefined;
  const previousOutput = previousStepId ? current[previousStepId].output : null;

  return (
    current[stepId].input ??
    buildStepInput(
      stepId,
      previousOutput,
      uploads,
      stepIndex > 1 ? current.lin.output : undefined,
    )
  );
}

export function invalidateDownstreamSteps(
  current: Record<PipelineStepId, PipelineStepState>,
  fromStepId: PipelineStepId,
  uploads: ParsedJsonUpload[],
): Record<PipelineStepId, PipelineStepState> {
  const fromIndex = PIPELINE_STEP_IDS.indexOf(fromStepId);
  const next = { ...current };

  for (
    let index = fromIndex + 1;
    index < PIPELINE_STEP_IDS.length;
    index += 1
  ) {
    const stepId = PIPELINE_STEP_IDS[index];
    const previousStepId = PIPELINE_STEP_IDS[index - 1];
    const previousOutput = next[previousStepId]?.output ?? null;

    next[stepId] = {
      ...createInitialStepState(),
      status: previousOutput ? 'ready' : 'idle',
      input: previousOutput
        ? buildStepInput(
            stepId,
            previousOutput,
            uploads,
            next.lin?.output ?? null,
          )
        : null,
    };
  }

  return next;
}
